<template>
  <div class="input-wrapper">
    <input
      :class="['custom-input', className]"
      @input="handleInput"
      :disabled="disabled"
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      :style="{ paddingLeft: inputType !== '' ? '60px' : '25px' }"
    />

    <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"
      v-if="inputType === 'email'">
      <path
        d="M18 0.78125H2C0.9 0.78125 0.00999999 1.68125 0.00999999 2.78125L0 14.7812C0 15.8813 0.9 16.7812 2 16.7812H18C19.1 16.7812 20 15.8813 20 14.7812V2.78125C20 1.68125 19.1 0.78125 18 0.78125ZM18 4.78125L10 9.78125L2 4.78125V2.78125L10 7.78125L18 2.78125V4.78125Z"
        fill="#AAA" />
    </svg>

    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"
      v-if="inputType === 'password'">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M3.25 8.83625V6.78125C3.25 4.99104 3.96116 3.27415 5.22703 2.00828C6.4929 0.742409 8.20979 0.03125 10 0.03125C11.7902 0.03125 13.5071 0.742409 14.773 2.00828C16.0388 3.27415 16.75 4.99104 16.75 6.78125V8.83625C17.865 8.91925 18.59 9.12925 19.121 9.66025C20 10.5382 20 11.9532 20 14.7812C20 17.6092 20 19.0243 19.121 19.9023C18.243 20.7812 16.828 20.7812 14 20.7812H6C3.172 20.7812 1.757 20.7812 0.879 19.9023C-5.96046e-08 19.0243 0 17.6092 0 14.7812C0 11.9532 -5.96046e-08 10.5382 0.879 9.66025C1.409 9.12925 2.135 8.91925 3.25 8.83625ZM4.75 6.78125C4.75 5.38886 5.30312 4.0535 6.28769 3.06894C7.27225 2.08437 8.60761 1.53125 10 1.53125C11.3924 1.53125 12.7277 2.08437 13.7123 3.06894C14.6969 4.0535 15.25 5.38886 15.25 6.78125V8.78525C14.8673 8.78192 14.4507 8.78058 14 8.78125H6C5.54867 8.78058 5.132 8.78192 4.75 8.78525V6.78125Z"
        fill="#AAA" />
    </svg>

    <svg width="26" height="26" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="icon"
      v-if="inputType === 'text'">
      <path d="M3 4V20H21V4H3M19 18H5V6H19V18M7 12H17V14H7V12M7 9H17V11H7V9Z" fill="#AAA" />
    </svg>

    <UserIcon class="icon" fill="#AAA" v-if="inputType === 'username'" />
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import UserIcon from "../icons/User.vue";

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  className: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: "text"
  },
  placeholder: {
    type: String,
    default: ""
  },
  inputType: {
    type: String,
    default: ""
  },
});

const emit = defineEmits(['update:modelValue']);

const handleInput = (event) => {
  emit('update:modelValue', event.target.value);
};
</script>

<style scoped>
.input-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
}

.input-wrapper .icon {
  position: absolute;
  left: 25px;
  top: 18px;
}

.custom-input {
  width: 100%;
  padding: 18px 25px 18px 25px;
  font-size: 16px;
  font-weight: 500;
  color: #22282b;
  line-height: 22.54px;
  border-radius: 100px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
  background-color: #f6f6f6;
}

.custom-input:focus {
  outline: none;
  border-color: #3182ce;
}

.custom-input::placeholder {
  color: #22282b;
}

.custom-input:disabled {
  background-color: #e0e0e0;
  cursor: not-allowed;
  border-color: #bdbdbd;
}
</style>
